<template>
  <div class="transition">
    <div class="transition-items">
      <div class="icon-items">
        <BasicIcon
          name="danger"
          active
        />
      </div>

      <BasicText>
        Vous ne pouvez pas sélectionner un établissement inactif, merci de sélectionner un autre établissement
      </BasicText>
    </div>
  </div>
</template>

<script setup lang="ts"></script>
<style lang="less" scoped>
  @import './ChoixCarte.less';

  .icon-items {
    background-color: white;
    color: @warning-500;
    align-self: center;
    margin-bottom: 10px;
    svg {
      fill: @warning-500;
      transform: scale(3);
    }
  }
</style>
